import { forwardRef } from "react";
import {
  ListBoxItem as ListBoxItemPrimitive,
  ListBoxItemProps as ListBoxItemPropsPrimitive,
} from "react-aria-components";

import { getBoxProps } from "@/components/Box/Box";
import { mergeProps } from "@/utils/reactExtensions";

import styles from "./AutocompleteItem.module.scss";
import { getSurfaceProps } from "../Surface/Surface";

export type AutocompleteItemProps = ListBoxItemPropsPrimitive & {
  children?: React.ReactNode;
};

export const AutocompleteItem = /*#__PURE__*/ (function () {
  const AutocompleteItem = forwardRef<HTMLDivElement, AutocompleteItemProps>(
    ({ children, ...props }, ref) => (
      <ListBoxItemPrimitive
        ref={ref}
        {...mergeProps(
          props,
          getBoxProps({ px: "xs", py: "2xs" }),
          getSurfaceProps({ type: "highlight", customPropsOnly: true }),
          {
            className: styles.autoCompleteItem,
          }
        )}
      >
        {children}
      </ListBoxItemPrimitive>
    )
  );

  AutocompleteItem.displayName = "AutocompleteItem";

  return AutocompleteItem;
})();
